import { panelClass } from './portal';

const Bar = ({ className }: { className: string }) => (
  <div className={`animate-pulse rounded-md bg-gray-100 ${className}`} />
);

export const JobCardSkeleton = () => (
  <div className={`${panelClass} p-5 sm:p-6`}>
    <div className="flex gap-4">
      <Bar className="h-11 w-11 shrink-0 !rounded-xl" />
      <div className="flex-1">
        <div className="flex justify-between gap-4">
          <div className="flex-1 space-y-2">
            <Bar className="h-4 w-1/2" />
            <Bar className="h-3.5 w-1/3" />
          </div>
          <Bar className="h-8 w-16 !rounded-full" />
        </div>
        <div className="mt-4 flex gap-4">
          <Bar className="h-3.5 w-20" />
          <Bar className="h-3.5 w-28" />
          <Bar className="h-3.5 w-20" />
        </div>
        <div className="mt-4 space-y-2">
          <Bar className="h-3.5 w-full" />
          <Bar className="h-3.5 w-4/5" />
        </div>
        <div className="mt-5 flex justify-between border-t border-gray-100 pt-4">
          <Bar className="h-3 w-24" />
          <Bar className="h-3 w-28" />
        </div>
      </div>
    </div>
  </div>
);
